export const sanitiseNhsNumber = (nhsNumberInputValue: string) => {
    return nhsNumberInputValue.replace(/ /g, "");
};
